
import { MathBase } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextFieldAutoSize } from "@goodgamestudios/createjs-utilities";
import { Power3 } from "gsap";
import { TweenMaxGroup } from "../helper/TweenMaxGroup";
import { TweenMaxGroupHelper } from "../helper/TweenMaxGroupHelper";
import { Poker2Dialog } from "./Poker2Dialog";
import { Poker2FadingDialogProperties } from "./Poker2FadingDialogProperties";
import Container = createjs.Container;

export class Poker2FadingDialog extends Poker2Dialog {
    public static NAME: string = "Poker2FadingDialog";
    private static FONT_Y_OFFSET: number = 3;
    private _twg_alphaTween: TweenMaxGroup;

    constructor(disp: Container) {
        super(disp);

        // enable user to hide the hint dialog immediately if he clicks on the lightbox background
        this.hasLightBoxBehaviour = true;
    }

    protected applyProperties(): void {
        super.applyProperties();

        TextFieldHelper.changeTextFromatSizeByTextWidth(20, this.fadeDialog.txt_copy, this.fadeProperties.copy, 5);

        // center textfield
        this.fadeDialog.txt_copy.autoSize = TextFieldAutoSize.CENTER;
        this.fadeDialog.txt_copy.y = Math.round((this.fadeDialog.window.height - this.fadeDialog.txt_copy.textHeight) / 2) - Poker2FadingDialog.FONT_Y_OFFSET;
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = MathBase.min((this.disp.stage.stageHeight / 600), (this.disp.stage.stageWidth / 800));
            this.disp.x = this.dispBounds.left - (this.dispBounds.width * this.disp.scaleX) / 2 + (800 * this.disp.scaleX) / 2 + this.layoutManager.gameNullPoint;
            this.disp.y = this.dispBounds.top - (this.dispBounds.height * this.disp.scaleY) / 2 + (600 * this.disp.scaleY) / 2;
        }
    }

    public show(): void {
        super.show();
        this.fadeDialog.visible = true;

        TweenMaxGroupHelper.disposeTweenMaxGroupInstance(this._twg_alphaTween);
        this._twg_alphaTween = new TweenMaxGroup();
        this._twg_alphaTween.to(this.fadeDialog, 0.7, { alpha: 1, ease: Power3.easeInOut, delay: 0.2, onComplete: this.bindFunction(this.onFadeInComplete) });
        this._twg_alphaTween.play();
    }

    public fadeOut(duration: number = 1.0): void {
        TweenMaxGroupHelper.disposeTweenMaxGroupInstance(this._twg_alphaTween);
        this._twg_alphaTween = new TweenMaxGroup();
        this._twg_alphaTween.to(this.fadeDialog, duration, { alpha: 0, ease: Power3.easeOut, onComplete: this.bindFunction(this.onFadeOutComplete) });
        this._twg_alphaTween.play();
    }

    private onFadeInComplete(): void {
        this._twg_alphaTween = new TweenMaxGroup();
        this._twg_alphaTween.to(this.fadeDialog, 0.5, { alpha: 0, ease: Power3.easeOut, delay: this.fadeProperties.lifeTime, onComplete: this.bindFunction(this.onFadeOutComplete) });
        this._twg_alphaTween.play();
    }

    private onFadeOutComplete(): void {
        TweenMaxGroupHelper.disposeTweenMaxGroupInstance(this._twg_alphaTween);
        this.fadeDialog.visible = false;
        // destroy this dialog
        Poker2LayoutManager.getInstance().clearDialogByInstance(this);
    }

    public destroy(): void {
        super.destroy();
        TweenMaxGroupHelper.disposeTweenMaxGroupInstance(this._twg_alphaTween);
    }

    public get fadeProperties(): Poker2FadingDialogProperties {
        return this.properties as Poker2FadingDialogProperties;
    }

    protected get fadeDialog(): Library.PokerInterface.PokerStandardFade {
        return this.disp as Library.PokerInterface.PokerStandardFade;
    }
}

import { Poker2LayoutManager } from "../Poker2LayoutManager";
